import { useParams } from 'next/navigation';
import { useProductStore } from 'src/modules/products/stores/productStore';
import { useProjectsContext } from 'src/modules/projects/context';

import { buildProjectSections, type Section } from './sections';

export type { Item, Section } from './sections';
export { buildProjectSections } from './sections';

export const useProjectsSections = (): Section[] => {
  const params = useParams();
  const { project } = useProjectsContext();
  const activeProduct = useProductStore((s) => s.activeProduct);
  const slug = params?.slug as string;

  return buildProjectSections(slug, activeProduct, project);
};
